<template>
	<header class="custom-header">
		<div class="header-content">
			<img :src="require('@/assets/lelogo.png')" class="header-logo" />
			<div class="header-text">
				<h1>小全车管</h1>
				<p class="subtitle">应用协议与政策文档</p>
			</div>
		</div>
	</header>

	<div class="container">
		<div class="card" @click="scrollToDocument('agreement')">
			<div class="icon">📄</div>
			<h2>APP服务协议</h2>
			<p>使用小全车管服务前需同意的条款和条件，包括用户权利与义务、服务使用规范等内容。</p>
			<a @click="scrollToDocument('agreement')" class="btn">查看详情</a>
		</div>

		<div class="card" @click="scrollToDocument('privacy')">
			<div class="icon">🔒</div>
			<h2>APP隐私政策</h2>
			<p>我们如何收集、使用、存储和保护您的个人信息，以及您对个人数据的控制权利。</p>
			<a @click="scrollToDocument('privacy')" class="btn">查看详情</a>
		</div>

		<div class="card" @click="scrollToDocument('children')">
			<div class="icon">👶</div>
			<h2>儿童隐私保护声明</h2>
			<p>特别针对未成年人的隐私保护措施，以及家长和监护人的责任与权利说明。</p>
			<a @click="scrollToDocument('children')" class="btn">查看详情</a>
		</div>

		<div class="card" @click="scrollToDocument('collection')">
			<div class="icon">📋</div>
			<h2>个人信息收集清单</h2>
			<p>明确列出我们会收集哪些个人信息、收集目的以及这些信息的使用方式。</p>
			<a @click="scrollToDocument('collection')" class="btn">查看详情</a>
		</div>

		<div class="card" @click="scrollToDocument('third-party')">
			<div class="icon">🔄</div>
			<h2>第三方共享信息清单</h2>
			<p>我们可能与哪些第三方共享信息、共享目的以及这些第三方的隐私保护措施。</p>
			<a @click="scrollToDocument('third-party')" class="btn">查看详情</a>
		</div>
	</div>

	<div id="agreement" class="document">
		<h2>小全车管APP服务协议</h2>
		<div class="document-content">
			<div class="document-box">
				<div class="text">
					<text style="color: black;">应用运营方:</text>
					<text>深圳乐漂科技有限公司</text>
				</div>
				<div class="text">
					<text style="color: black;">应用研发方:</text>
					<text>深圳乐漂科技有限公司</text>
				</div>
				<div class="text">
					<text style="color: black;">注册地址:</text>
					<text>深圳市南山区粤海街道高新区社区高新南七道020号高新工业村R2-A座210</text>
				</div>
				<div class="text">
					<text style="color: black;">联系方式:</text>
					<text>dev@ledrift.net</text>
				</div>
			</div>
			<h3>重要提示</h3>
			<p>欢迎您使用深圳乐漂科技有限公司（以下简称"小全"或"我们")提供的"小全车管"服务。请您在使用我们的服务前，仔细阅读并充分理解《用户服务协议》（以下简称"本协议"）全部内容。除非您已完全接受本协议，否则请勿使用我们的服务。
			</p>

			<h3>一、协议的范围</h3>
			<p>1.1 本协议是您与深圳乐漂科技有限公司之间关于您下载、安装、使用"小全车管"应用程序及相关服务所订立的协议。</p>
			<p>1.2 本协议内容同时包括《小全车管隐私政策》、《儿童隐私保护声明》、《个人信息收集清单》及《第三方共享信息清单》等。上述文件均为本协议不可分割的一部分。</p>

			<h3>二、服务内容</h3>
			<p>2.1
				小全车管通过物联网技术为您提供与智能电动摩托车、滑板车等出行工具相关的操作与管理服务，包括但不限于：车辆组装(扫描车辆信息与扫描仪表信息绑定)、车辆测试(扫描二维码测试车辆上下电)、核销车辆(提交表单核销车辆)、车管控车(扫描二维码控车,进行上下电等操作)。
			</p>

			<h3>三、账号安全</h3>
			<p>3.1您应妥善保管账号密码，并对使用该账号进行的所有活动承担责任。</p>


			<h3>四、用户行为规范</h3>
			<p>4.1 您承诺在使用服务时遵守所有适用的法律法规，并不得从事任何非法、犯罪或侵犯他人权利的活动。</p>
			<p>4.2 不得破坏、拆卸、改装车辆或其任何物联网组件。</p>

			<h3>五、知识产权声明</h3>
			<p>5.1 本App及其所有的元素的知识产权均归深圳乐漂或其授权方所有。</p>

			<h3>六、免责与责任限制</h3>
			<p>6.1 车辆的位置、状态等信息可能因网络、信号、硬件故障等原因出现延迟或误差，我们对此类信息的准确性不作担保。</p>

			<h3>七、协议终止</h3>
			<p>7.1 您有权通过停止使用、卸载App或注销账号等方式终止本协议。</p>
			<p>7.2 如您违反本协议，我们有权暂停或终止向您提供服务。</p>

			<h3>八、其他</h3>
			<p>8.1 本协议受中华人民共和国法律管辖。</p>
			<p>8.2 若有任何争议，应首先通过友好协商解决；协商不成的，任何一方均可向深圳市南山区人民法院提起诉讼。</p>

			<p class="highlight">生效日期：2025年05月01日</p>
		</div>
		<a href="#" class="back-btn" @click.prevent="scrollToTop">返回顶部</a>
	</div>

	<div id="privacy" class="document">
		<h2>小全车管隐私政策</h2>

		<div class="document-content">
			<div class="document-box">
				<div class="text">
					<text style="color: black;">应用运营方:</text>
					<text>深圳乐漂科技有限公司</text>
				</div>
				<div class="text">
					<text style="color: black;">应用研发方:</text>
					<text>深圳乐漂科技有限公司</text>
				</div>
				<div class="text">
					<text style="color: black;">注册地址:</text>
					<text>深圳市南山区粤海街道高新区社区高新南七道020号高新工业村R2-A座210</text>
				</div>
				<div class="text">
					<text style="color: black;">联系方式:</text>
					<text>dev@ledrift.net</text>
				</div>
			</div>
			<h3>引言</h3>
			<p>深圳乐漂科技有限公司深知个人信息对您的重要性，并承诺保护您的隐私安全。本《隐私政策》旨在向您说明，在您使用"小全车管"App时，我们如何收集、使用、存储、共享和保护您的个人信息。</p>

			<h3>一、我们如何收集和使用您的个人信息</h3>
			<p>我们仅会出于以下目的和功能，收集和使用您的个人信息：</p>
			<p>1. 账号登录：使用内部提供账号，用于验证身份、登录。</p>
			<p>2. 核心物联网功能：位置信息用于定位车辆、导航寻车；蓝牙权限用于连接并控制车辆。</p>
			<p>3. 设备信息：用于保障账号安全、识别App崩溃问题及进行数据统计分析。</p>

			<div>
				<p>我们需要说明权限如下:</p>
				<p>1、我们需要访问摄像头进行拍照（或本地图册），以拍照（或本地图片）作为扫码内容，用于支持用户通过拍摄照片的方式，直接获取图像将图像作为扫描二维码的内容。</p>


				<p>2、我们需要获取设备位置权限与写入权限，核心用于蓝牙功能的正常实现。通过位置权限，应用可精准搜索并匹配车辆蓝牙设备，建立稳定连接；通过写入权限，能向 BLE
					蓝牙设备传输合规数据，完成设备连接后的指令下发与数据交互，确保蓝牙相关功能（如设备控制、数据同步）顺畅运行，保障车辆蓝牙交互的安全性与稳定性。
				</p>
				<p>3、我们需要在你分享或接被分享的信息时，需要在本地访问你的剪切板，读取其中包含的口令，分享码，链接，以实现跳转，分享等功能或服务。</p>

				<p>4、收集/共享信息:网络访问，获取Wi-Fi状态，读取电话状态，使用存储权限，设备标识信息(包括IMEI、IMSI、SUPI、SUCI、设备序列号、OAID、MEID、MAC地址、ICCID)，剪切板，位置，联系人，本机电话号码，图片，音视频等个人信息
				</p>
			</div>

			<h3>二、我们如何使用Cookie和同类技术</h3>
			<p>我们可能使用Cookie来记录您的登录状态、偏好设置，以提升服务体验。</p>

			<h3>三、我们如何共享、转让、公开披露您的个人信息</h3>
			<p>1. 共享：我们不会出售您的个人信息。我们可能会与地图服务提供商、推送服务提供商等第三方共享必要的个人信息。</p>
			<p>2. 转让与公开披露：我们不会将您的个人信息转让给任何公司、组织和个人，也不会公开披露，除非事先获得您的明确同意或法律法规强制要求。</p>

			<h3>四、我们如何存储和保护您的个人信息</h3>
			<p>1. 存储地点：我们在中华人民共和国境内运营中收集和产生的个人信息，将存储在中国境内。</p>
			<p>2. 存储期限：我们仅在为实现本政策所述目的所必需的期限内保留您的信息。</p>
			<p>3. 安全措施：我们采用多种安全技术和管理措施来保护您的信息不被未授权访问、泄露、篡改或毁坏。</p>

			<h3>五、您的权利</h3>
			<p>您有权访问、更正、删除您的个人信息；改变您授权同意的范围；注销您的账户；获取个人信息副本。</p>

			<h3>六、本政策如何更新</h3>
			<p>我们可能会适时更新本政策。更新后，我们会通过App推送通知、网站公告等显著方式提醒您。</p>

			<h3>七、如何联系我们</h3>
			<p>如果您对本政策有任何疑问、意见或建议，请通过以下方式联系我们：</p>
			<p>公司名称：深圳乐漂科技有限公司</p>
			<p>数据保护负责人邮箱：dev@ledrift.net</p>
			<p>地址：深圳市南山区粤海街道高新区社区高新南七道020号高新工业村R2-A座210</p>

			<p class="highlight">生效日期：2025年05月01日</p>
		</div>
		<a href="#" class="back-btn" @click.prevent="scrollToTop">返回顶部</a>
	</div>

	<div id="children" class="document">
		<h2>儿童隐私保护声明</h2>

		<div class="document-content">
			<div class="document-box">
				<div class="text">
					<text style="color: black;">应用运营方:</text>
					<text>深圳乐漂科技有限公司</text>
				</div>
				<div class="text">
					<text style="color: black;">应用研发方:</text>
					<text>深圳乐漂科技有限公司</text>
				</div>
				<div class="text">
					<text style="color: black;">注册地址:</text>
					<text>深圳市南山区粤海街道高新区社区高新南七道020号高新工业村R2-A座210</text>
				</div>
				<div class="text">
					<text style="color: black;">联系方式:</text>
					<text>dev@ledrift.net</text>
				</div>
			</div>
			<h3>我们的立场</h3>
			<p>深圳乐漂科技有限公司深知儿童（指未满十四周岁的未成年人）个人信息安全的重要性。我们根据《个人信息保护法》等相关法律法规，制定了本《儿童隐私保护声明》。</p>

			<h3>一、服务对象</h3>
			<p>我们的产品与服务并非专门面向儿童设计，我们也不主动吸引儿童注册或使用。</p>

			<h3>二、信息的收集与使用</h3>
			<p>如果我们发现自己在未获得监护人同意的情况下收集了儿童的个人信息，我们会设法尽快删除相关数据。</p>
			<p>我们将仅在为儿童提供所需服务所必需时，或在法律允许的情况下，并在获得监护人事先明确同意后，才收集、使用或披露儿童的个人信息。</p>

			<h3>三、信息共享</h3>
			<p>我们不会在未获得监护人同意的情况下，向任何第三方共享或转让儿童的个人信息，除非法律法规另有规定。</p>

			<h3>四、安全保护</h3>
			<p>我们严格保护儿童个人信息的安全，并采取了加密、访问控制等安全措施。</p>

			<h3>五、监护人的权利</h3>
			<p>监护人可以随时要求访问、更正或删除我们收集的其监护的儿童的个人信息，也可以要求我们停止进一步收集或使用。</p>

			<h3>六、联系我们</h3>
			<p>如果您是儿童的父母或监护人，请仔细阅读本声明。如果您发现您的孩子在未征得您同意的情况下向我们提供了个人信息，请通过dev@ledrift.net立即与我们联系。</p>

			<p class="highlight">生效日期：2025年05月01日</p>
		</div>
		<a href="#" class="back-btn" @click.prevent="scrollToTop">返回顶部</a>
	</div>

	<div id="collection" class="document">
		<h2>个人信息收集清单</h2>

		<div class="document-content">
			<div class="document-box">
				<div class="text">
					<text style="color: black;">应用运营方:</text>
					<text>深圳乐漂科技有限公司</text>
				</div>
				<div class="text">
					<text style="color: black;">应用研发方:</text>
					<text>深圳乐漂科技有限公司</text>
				</div>
				<div class="text">
					<text style="color: black;">注册地址:</text>
					<text>深圳市南山区粤海街道高新区社区高新南七道020号高新工业村R2-A座210</text>
				</div>
				<div class="text">
					<text style="color: black;">联系方式:</text>
					<text>dev@ledrift.net</text>
				</div>
			</div>
			<h3>引言</h3>
			<p>根据国家相关法律法规要求，以下是"小全车管"App收集和使用个人信息的清单。</p>

			<h3>一、收集的个人信息类型及用途</h3>
			<p><strong>1. 手机号码</strong></p>
			<p>用途：用于注册/登录账号、接收服务通知</p>
			<p>收集方式：用户输入</p>
			<p>是否必需：是</p>

			<p><strong>2. 位置信息（精确/粗略）</strong></p>
			<p>用途：定位车辆、导航寻车、记录轨迹、电子围栏</p>
			<p>收集方式：用户授权后通过设备系统获取</p>
			<p>是否必需：核心功能必需</p>

			<p><strong>3. 蓝牙信息</strong></p>
			<p>用途：扫描、发现、连接并控制智能车辆</p>
			<p>收集方式：用户授权后通过设备系统获取</p>
			<p>是否必需：核心功能必需</p>

			<p><strong>4. 设备信息（设备型号、OS版本、唯一设备标识符)</strong></p>
			<p>用途：保障账号与交易安全、识别App崩溃、数据统计分析</p>
			<p>收集方式：App自动收集</p>
			<p>是否必需：是</p>

			<p><strong>5. 服务日志信息（操作记录、IP地址）</strong></p>
			<p>用途：维护服务正常运行、安全分析、优化服务</p>
			<p>收集方式：App自动收集</p>
			<p>是否必需：是</p>

			<h3>二、说明</h3>
			<p>"必需"是指缺少该信息会导致相关核心功能无法实现。</p>
			<p>您可以通过设备操作系统设置随时关闭位置、蓝牙等权限，但这将影响对应功能的正常使用。</p>

			<p class="highlight">生效日期：2025年05月01日</p>
		</div>
		<a href="#" class="back-btn" @click.prevent="scrollToTop">返回顶部</a>
	</div>

	<div id="third-party" class="document">
		<h2>第三方共享信息清单</h2>

		<div class="document-content">
			<div class="document-box">
				<div class="text">
					<text style="color: black;">应用运营方:</text>
					<text>深圳乐漂科技有限公司</text>
				</div>
				<div class="text">
					<text style="color: black;">应用研发方:</text>
					<text>深圳乐漂科技有限公司</text>
				</div>
				<div class="text">
					<text style="color: black;">注册地址:</text>
					<text>深圳市南山区粤海街道高新区社区高新南七道020号高新工业村R2-A座210</text>
				</div>
				<div class="text">
					<text style="color: black;">联系方式:</text>
					<text>dev@ledrift.net</text>
				</div>
			</div>
			<h3>引言</h3>
			<p>为保障"小全车管"App相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方提供的软件工具开发包（SDK）。我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全评估，并要求其按照法律法规要求处理您的信息。
			</p>

			<h3>一、第三方SDK列表</h3>
			<p><strong>1. 高德地图SDK</strong></p>
			<p>第三方公司：高德软件有限公司</p>
			<p>共享目的：提供地图展示、定位、地理编码、轨迹记录服务</p>
			<p>共享信息类型：位置信息、设备信息（如IP地址、Mac地址）</p>
			<p>隐私政策链接：https://lbs.amap.com/home/privacy/</p>

			<p><strong>2. 个推SDK</strong></p>
			<p>第三方公司：浙江每日互动网络科技股份有限公司</p>
			<p>共享目的：用于向用户推送消息和通知</p>
			<p>共享信息类型：设备标识符（如OAID）、网络状态信息</p>
			<p>隐私政策链接：https://www.getui.com/privacy</p>

			<p><strong>3. 友盟+SDK</strong></p>
			<p>第三方公司：友盟同欣（北京）科技有限公司</p>
			<p>共享目的：统计App使用情况，分析数据以优化服务</p>
			<p>共享信息类型：设备信息（如IMEI/Android ID/IDFA）、应用列表（仅Android）、匿名化的使用数据</p>
			<p>隐私政策链接：https://www.umeng.com/page/policy</p>

			<h3>二、重要提示</h3>
			<p>此清单必须与App中实际集成的所有第三方SDK完全一致！</p>
			<p>请务必前往各第三方官网查看其最新的隐私政策，并将链接准确填入。</p>
			<p>上表仅为示例，您需要根据实际集成情况完整列出所有SDK。</p>

			<p class="highlight">生效日期：2025年05月01日</p>
		</div>
		<a href="#" class="back-btn" @click.prevent="scrollToTop">返回顶部</a>
	</div>

	<div class="company-info">
		<h3>公司信息</h3>
		<p><strong>公司全称：</strong>深圳乐漂科技有限公司</p>
		<p><strong>公司简称：</strong>深圳乐漂</p>
		<p><strong>公司地址：</strong>深圳市南山区粤海街道高新区社区高新南七道020号高新工业村R2-A座210</p>
		<p><strong>联系邮箱：</strong>dev@ledrift.net</p>
	</div>

	<footer>
		<p>© 2023 深圳乐漂科技有限公司 版权所有</p>
		<p>小全车管 - 让出行更轻松</p>
	</footer>
</template>

<script>
	export default {
		name: 'PolicyDocument',
		data() {
			return {
				activeDocument: null // 初始没有激活的文档
			}
		},
		methods: {
			scrollToDocument(id) {
				this.activeDocument = id; // 设置当前激活的文档

				// 使用nextTick确保DOM更新后再执行滚动
				this.$nextTick(() => {
					const element = document.getElementById(id);
					if (element) {
						element.scrollIntoView({
							behavior: 'smooth',
							block: 'start'
						});
						window.history.pushState(null, null, `#${id}`);
					}
				});
			},
			scrollToTop() {
				// 使用更现代的滚动方式
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				});

				// 清除URL中的哈希值
				window.history.pushState(null, null, window.location.pathname);
			}
		},
		mounted() {
			// 检查URL中是否有哈希值，如果有则滚动到对应部分
			if (window.location.hash) {
				const targetId = window.location.hash.substring(1);
				this.activeDocument = targetId;
				setTimeout(() => {
					this.scrollToDocument(targetId);
				}, 100);
			}
		}
	}
</script>

<style>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
		font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
	}

	body {
		background-color: #f5f7fa;
		color: #333;
		line-height: 1.6;
		padding: 20px;
		/* max-width: 1200px; */
	}

	.document-box {
		width: 100%;
		margin: 0 auto;
		height: 160px;
		font-size: 16px;
		padding: 20px;
		background-color: #e8f4fc;
		border-radius: 15px;
	}

	.text {
		margin: 5px 0;
	}

	.custom-header {
		padding: 30px 0;
		background-color: #ffffff;
		border-radius: 10px;
		margin-bottom: 30px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		display: flex;
		justify-content: center;
	}

	.header-content {
		display: flex;
		align-items: center;
		max-width: 1200px;
		width: 100%;
		padding: 0 60px;
	}

	.header-logo {
		width: 124rpx;
		height: 124rpx;
	}

	.header-text {
		flex: 1;
		text-align: center;
	}

	.header-text h1 {
		font-size: 2.5rem;
		margin-bottom: 10px;
	}

	.header-text .subtitle {
		font-size: 1.2rem;
		opacity: 0.9;
	}

	h1 {
		font-size: 2.5rem;
		margin-bottom: 10px;
	}

	.subtitle {
		font-size: 1.2rem;
		opacity: 0.9;
	}

	.container {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
		gap: 25px;
		margin-bottom: 40px;
	}

	.card {
		background: white;
		border-radius: 12px;
		padding: 25px;
		box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
		transition: transform 0.3s ease, box-shadow 0.3s ease;
		cursor: pointer;
		display: flex;
		flex-direction: column;
	}

	.card:hover {
		transform: translateY(-5px);
		box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
	}

	.card h2 {
		color: #2c3e50;
		margin-bottom: 15px;
		font-size: 1.5rem;
		border-bottom: 2px solid #3498db;
		padding-bottom: 10px;
	}

	.card p {
		color: #555;
		flex-grow: 1;
		margin-bottom: 20px;
	}

	.card .icon {
		font-size: 2.5rem;
		text-align: center;
		margin-bottom: 15px;
		color: #3498db;
	}

	.btn {
		display: inline-block;
		background: #fb7c00;
		color: white;
		padding: 12px 20px;
		border-radius: 6px;
		text-decoration: none;
		text-align: center;
		font-weight: 500;
		transition: background 0.3s ease;
	}

	.document {
		background: white;
		border-radius: 12px;
		padding: 40px;
		margin-bottom: 40px;
		box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
	}

	.document h2 {
		color: #2c3e50;
		margin-bottom: 20px;
		text-align: center;
		font-size: 1.8rem;
	}

	.document-content {
		padding: 20px;
		background: #f9f9f9;
		border-radius: 8px;
		max-height: 500px;
		overflow-y: auto;
	}

	.document-content h3 {
		color: #3498db;
		margin: 20px 0 10px;
	}

	.document-content p {
		margin-bottom: 15px;
	}

	.back-btn {
		display: inline-block;
		margin-top: 20px;
		background: #7f8c8d;
		color: white;
		padding: 10px 18px;
		border-radius: 6px;
		text-decoration: none;
		transition: background 0.3s ease;
	}

	.back-btn:hover {
		background: #636e72;
	}

	footer {
		text-align: center;
		padding: 20px;
		color: #7f8c8d;
		font-size: 0.9rem;
		border-top: 1px solid #ddd;
		margin-top: 20px;
	}

	.company-info {
		margin-top: 30px;
		padding: 20px;
		background: white;
		border-radius: 10px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	}

	.company-info h3 {
		color: #2c3e50;
		margin-bottom: 15px;
		text-align: center;
	}

	.company-info p {
		margin: 10px;
	}

	.highlight {
		color: #e74c3c;
		font-weight: 500;
	}

	@media (max-width: 768px) {
		.container {
			grid-template-columns: 1fr;
		}

		h1 {
			font-size: 2rem;
		}

		.document {
			padding: 20px;
		}
	}
</style>